import moment from 'moment';

type DateFormatterProps = {
  text: string;
  inputFormat?: string;
  unixTimestamp?: boolean;
};

const DateFormatter = ({ text, inputFormat, unixTimestamp }: DateFormatterProps) => {
  const date = unixTimestamp ? moment.unix(parseInt(text, 10)) : moment(text, inputFormat);

  return date.format('ll');
};

export default DateFormatter;
